import React from "react";

import { PlusCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";

import { formatCurrency } from "../utils";

import { ReactComponent as ArrowUpCircleIcon } from "../../../../assets/images/subscriptions/arrow-up-circle-line.svg";

import "./SubscriptionPaymentSummary.css";

export default function SubscriptionPaymentSummary({
  total = 0,
  loading = false,
  onTopUp,
  onAddToSubscription,
}) {
  const hasTotal = total > 0;

  return (
    <div className="SubscriptionPaymentSummary">
      <div className="SubscriptionPaymentSummary__Actions">
        <span className="SubscriptionPaymentSummary__Total">
          {"Total - "}
          <strong>{formatCurrency(total)}</strong>
        </span>

        <Button
          type="default"
          icon={<ArrowUpCircleIcon />}
          className="SubscriptionPaymentSummary__TopUpButton"
          onClick={onTopUp}
          disabled={!hasTotal || loading}
          loading={loading}
        >
          Top-up now
        </Button>
        <Button
          type="primary"
          icon={<PlusCircleOutlined />}
          className="SubscriptionPaymentSummary__AddButton"
          onClick={onAddToSubscription}
          disabled={!hasTotal || loading}
          loading={loading}
        >
          Update Current Billing
        </Button>
      </div>
    </div>
  );
}
